export enum CoreInjectorTokens {
  Environment = 'environment',
  LoginUrl = 'login-url',
}
